import {
  Action,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import { CartLine, InitiatePayment, PaymentGateWay } from '@/types/CartTypes';
import PaymentService from '@/services/paymentService';

@Module({
  namespaced: true,
})
class ShoppingCartModule extends VuexModule {
  cartLine: CartLine = {} as CartLine;
  paymentGateWayDto = {} as PaymentGateWay;
  payerCountryCode ="";
  payerNumber ="";

  get getPayerCountryCode() {
    return this.payerCountryCode;
  }

  get getPayerNumber() {
    return this.payerNumber;
  }


  get getCartLine() {
    return this.cartLine;
  }

  get getPaymentGateWayDto() {
    return this.paymentGateWayDto;
  }

  @Mutation
  setPayerCountryCode(payload: string) {
    this.payerCountryCode = payload;
  }

  @Mutation
  setPayerNumber(payload: string) {
    this.payerNumber = payload;
  }

  @Mutation
  setReceiverNo(recieverNo: string) {
    this.cartLine.receiveNumber = recieverNo;
  }

  @Mutation
  setSenderNo(senderNo: string) {
    this.cartLine.senderNumber = senderNo;
  }

  @Mutation
  setAccountNo(accountNo: string) {
    this.cartLine.accountNo = accountNo;
  }

  @Mutation
  setCart(prdtCatalogue: CartLine) {
    this.cartLine = prdtCatalogue
  }

  @Mutation
  paymentInitiated(dto: PaymentGateWay) {
    this.paymentGateWayDto = dto;
  }

  @Action({ commit: 'setCart', rawError: true })
  async addToCart(payload: CartLine): Promise<CartLine> {
    return payload;
  }

  @Action({ commit: 'setAccountNo', rawError: true })
  async addAccountNo(payload: string): Promise<string> {
    return payload;
  }

  @Action({ commit: 'setReceiverNo', rawError: true })
  async addReceiverNo(payload: string): Promise<string> {
    return payload;
  }

  @Action({ commit: 'setSenderNo', rawError: true })
  async addSenderNo(payload: string): Promise<string> {
    return payload;
  }

  @Action({ commit: 'paymentInitiated', rawError: true })
  async initiatePayment(payload: InitiatePayment): Promise<PaymentGateWay> {
    const result = PaymentService.initiatePayment(payload);
    return result;
  }

  @Action({ commit: 'setPayerCountryCode', rawError: true })
  async addPayerCountryCode(payload: string): Promise<string> {
    return payload;
  }

  @Action({ commit: 'setPayerNumber', rawError: true })
  async addPayerNumber(payload: string): Promise<string> {
    return payload;
  }
}

export default ShoppingCartModule;
